import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import BrowseSection from './sections/BrowseSection';
import EarningSection from './sections/EarningSection';
import SupportersSection from './sections/SupportersSection';
import {Message} from 'epic-diesel-common';
import {Affiliate} from '../../../shared/types';
import {SettingsState} from '../../reducers/settings.reducer';
import {ConfigState} from '../../reducers/config';
import useStyles from './Dashboard.styles';

export interface DashboardProps {
    messages: Record<string, string>;
    configState: ConfigState;
    settingsState: SettingsState;
    affiliateAccount: Affiliate;
    enableLink?: boolean;
}

const Dashboard: React.FC<DashboardProps> = ({
    messages,
    configState,
    settingsState,
    affiliateAccount,
    enableLink = true
}) => {
    const styles = useStyles();
    const {slug: creatorCode, createdAt} = affiliateAccount || {};
    const {payoutAccount} = settingsState || {};
    const isDraft = payoutAccount && payoutAccount.accountStatus === 'DRAFT';

    return (
        <>
            {isDraft && (
                <Grid item xs={12} style={{margin: '15px 0'}}>
                    <Typography className={styles.payoutWarning}>
                        <Message code="epic.affiliate.earnings.payout_warning" />
                    </Typography>
                </Grid>
            )}
            <Grid container spacing={6} className={styles.root}>
                <Grid item xl={9} lg={8} xs={12}>
                    <SupportersSection
                        messages={messages}
                        startDate={createdAt}
                        enableLink={enableLink}
                    />

                    <BrowseSection messages={messages} enableLink={enableLink} />
                </Grid>

                <Grid item xl={3} lg={4} xs={12}>
                    <EarningSection
                        messages={messages}
                        creatorCode={creatorCode}
                        configState={configState}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default Dashboard;
